/** 3.0·4.0 임시 비밀번호 평문 — 영문 소문자 + 숫자 (8자리 레거시 / 12자리) */
export const TEMP_PASSWORD_PATTERN = /^[a-z]{4}[0-9]{4}$|^[a-z]{6}[0-9]{6}$/;

/** @param {string} value */
export function isTemporaryPasswordPlain(value) {
  if (value == null || typeof value !== 'string') {
    return false;
  }
  return TEMP_PASSWORD_PATTERN.test(value.trim());
}

/** 로그인 API 전송용 — 임시 비밀번호는 평문, 일반 비밀번호는 SHA-256(Base64) */
export async function passwordForLoginApi(rawPassword, sha256Base64Fn) {
  const raw = String(rawPassword ?? '');
  if (isTemporaryPasswordPlain(raw)) {
    return raw.trim();
  }
  return sha256Base64Fn(raw);
}
